import type { ISEOProps } from "../types/core";

export const AgeProofsPageSEO: ISEOProps = {
  title: "Age Verification - Sugar Cribs",
  description:
    "Complete age verification to access Sugar Cribs content. Upload your ID for age verification.",
};
